"use strict";
export var Experiments = /* @__PURE__ */ ((Experiments2) => {
  Experiments2["AccountCTAs"] = "signin_login_connect_ctas";
  Experiments2["SwapPresets"] = "swap_presets";
  Experiments2["NativeTokenPercentageBuffer"] = "lp_native_eth_buffer";
  Experiments2["PrivateRpc"] = "private_rpc";
  return Experiments2;
})(Experiments || {});
export var Layers = /* @__PURE__ */ ((Layers2) => {
  Layers2["SwapPage"] = "swap-page";
  return Layers2;
})(Layers || {});
export var AccountCTAsExperimentGroup = /* @__PURE__ */ ((AccountCTAsExperimentGroup2) => {
  AccountCTAsExperimentGroup2["Control"] = "Control";
  AccountCTAsExperimentGroup2["SignInSignUp"] = "SignIn-SignUp";
  AccountCTAsExperimentGroup2["LogInCreateAccount"] = "LogIn-CreateAccount";
  return AccountCTAsExperimentGroup2;
})(AccountCTAsExperimentGroup || {});
export var NativeTokenPercentageBufferExperimentGroup = /* @__PURE__ */ ((NativeTokenPercentageBufferExperimentGroup2) => {
  NativeTokenPercentageBufferExperimentGroup2["Control"] = "Control";
  NativeTokenPercentageBufferExperimentGroup2["Buffer1"] = "Buffer1";
  return NativeTokenPercentageBufferExperimentGroup2;
})(NativeTokenPercentageBufferExperimentGroup || {});
export var ArbitrumXV2SamplingProperties = /* @__PURE__ */ ((ArbitrumXV2SamplingProperties2) => {
  ArbitrumXV2SamplingProperties2["RoutingType"] = "routingType";
  return ArbitrumXV2SamplingProperties2;
})(ArbitrumXV2SamplingProperties || {});
export var SwapPresetsProperties = /* @__PURE__ */ ((SwapPresetsProperties2) => {
  SwapPresetsProperties2["InputEnabled"] = "inputEnabled";
  SwapPresetsProperties2["OutputEnabled"] = "outputEnabled";
  return SwapPresetsProperties2;
})(SwapPresetsProperties || {});
export var PrivateRpcProperties = /* @__PURE__ */ ((PrivateRpcProperties2) => {
  PrivateRpcProperties2["FlashbotsEnabled"] = "flashbots_enabled";
  PrivateRpcProperties2["RefundPercent"] = "refund_percent";
  return PrivateRpcProperties2;
})(PrivateRpcProperties || {});
export const LayerProperties = {
  ["swap-page" /* SwapPage */]: Object.values(SwapPresetsProperties)
};
